import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import Popup from "../../../../../components/WMS/Mobile/Popup";
import {FormattedMessage} from "react-intl";
import CustomButton from "../../../../../components/CustomButton";
import { ReactComponent as PinIcon} from "assets/img/wms/pin.svg";
import pusherClient from "../../../../../utils/pusherClient";
import {ShipmentMessageSeverity, ShipmentMessageType} from "../../../../../utils/ShipmentMessageType";
import {getShipmentById} from "../../../../../api/shipment/getWithId";
import {Grid} from "@mui/material";
import {red500} from "../../../../../assets/jss/main";
import {Link} from "react-router-dom";

ClickAndCollectPackingModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handlePrintDocuments: PropTypes.func.isRequired,
    packingStep: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    setIsLoading: PropTypes.func.isRequired,
    validPrint: PropTypes.func.isRequired
};

function ClickAndCollectPackingModal({open, handleClose, handlePrintDocuments, packingStep, isLoading, setIsLoading, validPrint}) {
    const slipIsPrintedTimeout = useRef()

    const [errorMessage, setErrorMessage] = useState()

    const currentShipmentChannel = pusherClient.subscribe('shipment-'+packingStep.selectedShipment.shipmentId)

    currentShipmentChannel.bind(ShipmentMessageType.WAYBILL_PRINT_MESSAGE, (data) => handleShipmentMessage(data))

    function handleShipmentMessage (data) {
        clearTimeout(slipIsPrintedTimeout.current)
        if (ShipmentMessageSeverity.ERROR === data.severity) {
            setIsLoading(false)
            setErrorMessage(data.message)
        }
        if (ShipmentMessageSeverity.SUCCESS === data.severity) {
            validPrint()
        }
    }

    function handleValid (isReprint = false) {
        handlePrintDocuments(isReprint)
        slipIsPrintedTimeout.current = setTimeout(() => {
            getShipmentById(packingStep.selectedShipment.shipmentId).then((response) => {
                if (response.document && response.trackingNumber) {
                    validPrint()
                } else {
                    setIsLoading(false)
                    setErrorMessage(response.error ?? <FormattedMessage id={"wms.packing.modal.shipmentWeigh.defaultErrorMessage"}/>)
                }
            })
        }, 5000)
    }

    useEffect(() => {
        if (!open) {
            currentShipmentChannel.unbind(ShipmentMessageType.WAYBILL_PRINT_MESSAGE)
            currentShipmentChannel.unsubscribe('shipment-'+packingStep.selectedShipment.shipmentId)
        }
    }, [open]);

    return (
        <Popup
            open={open}
            onClose={handleClose}
            icon={<PinIcon/>}
            title={<FormattedMessage id={"wms.packing.modal.click&collect.title"}/>}
            subtitle={<FormattedMessage id={"wms.packing.modal.click&collect.subtitle"}/>}
        >
            {errorMessage && (
                <Grid container direction={"column"} gap={"8px"}>
                    <Grid container direction={"column"}>
                        <Grid item><FormattedMessage id={"wms.packing.modal.shipmentWeigh.error"}/></Grid>
                        <Grid item sx={{color: red500}}>{errorMessage}</Grid>
                    </Grid>
                    <Grid container direction={"column"}>
                        <Grid item><FormattedMessage id={"wms.packing.modal.shipmentWeigh.toOMS"}/></Grid>
                        <Grid item>
                            <Link target="_blank" to={"../picking/orders/show/"+packingStep.selectedShipment.orderId}><FormattedMessage id={"wms.packing.modal.shipmentWeigh.toOMS.link"}/></Link>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <CustomButton
                            loading={isLoading}
                            disabled={isLoading}
                            onClick={() => handleValid(true)}
                            fullWidth
                            color={"default"}
                            style={{marginTop: "8px"}}
                        >
                            {!isLoading ?
                                <FormattedMessage id={"wms.packing.modal.scanDropZone.printButton"}/> :
                                <FormattedMessage id={"wms.packing.modal.scanDropZone.printButton.isLoading"}/>
                            }

                        </CustomButton>
                    </Grid>
                </Grid>
            )}


            {!errorMessage && (
                <CustomButton
                    fullWidth
                    onClick={handleValid}
                    loading={isLoading}
                    disabled={isLoading}
                >
                    <FormattedMessage id={"wms.packing.modal.click&collect.validButton"}/>
                </CustomButton>
            )}
        </Popup>
    );
}

export default ClickAndCollectPackingModal;